<template>
  <span class="product-price">
    {{ prefix }}{{ parts.integer }}<span
      v-if="parts.decimal"
      class="price-decimal"
    >
      {{ parts.separator }}{{ parts.decimal }}
    </span>
    {{ currency }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  currency: { type: String, required: true },
  priceFirst: { type: String, required: true },
  priceSecond: { type: String, default: '' },
  plusClubPrice: { type: String, default: '' },
  inPlusClub: { type: Boolean, default: false },
  showFromText: { type: String, default: '' },
})

const { locale } = useI18n()

const resolvedPrice = computed(() => {
  const club = Number(props.plusClubPrice)
  const second = Number(props.priceSecond)
  const first = Number(props.priceFirst)

  if (props.inPlusClub && !isNaN(club) && club > 0) return club
  if (!isNaN(second) && second > 0) return second
  return isNaN(first) ? 0 : first
})

const parts = computed(() => {
  const isDot = ['hu', 'ro'].includes(locale.value)
  const [intRaw, decRaw] = resolvedPrice.value.toFixed(2).split('.')

  return {
    integer: Number(intRaw).toLocaleString(),
    decimal: decRaw === '00' ? null : decRaw,
    separator: isDot ? '.' : ',',
  }
})

const prefix = computed(() =>
    props.showFromText.trim() ? `${props.showFromText.trim()} ` : ''
)
</script>

<style scoped>
.price-decimal {
  font-size: .75em;
  position: relative;
  top: -0.23em;
  margin-left: 1px;
}
</style>
